<label class="cm-container">
    <input type="radio" [value]="$value()" [checked]="$checked()" [required]="$required()" [disabled]="$_disabled()" (change)="onChange()" />
    <i class="fa-light fa-circle cm-unchecked"></i>
    <i class="fa-regular fa-circle-dot cm-checked"></i>
    <ng-content></ng-content>
</label>
